export default {
  green: '#97af25',
  greenLight: '#e1ef9f',
  gray: '#555',
  grayLight: '#747374',
  grayLightest: '#bdc1c3',
  yellow: '#f0ad4e',
  red: '#d9534f',
}
